<alaris-dialog
	[closeAction]="close.bind(this)"
	[closeButtonText]="'actions.cancel'"
	[confirmAction]="confirm.bind(this)"
	[confirmButtonText]="confirmButtonText"
	[loading$]="loading$"
	class="alaris-dialog"
>
	<ng-container slot="header">
		<h3 class="title">
			@switch (data.type) {
				@case ('PackageRequest') {
					{{ 'purchase.packageRequestTitle' | translate }}
				}
				@case ('PlanRequest') {
					{{ 'purchase.planRequestTitle' | translate }}
				}
				@case ('SelectPlan') {
					{{ 'purchase.yourOrder' | translate }}
				}
				@case ('ShopNow') {
					{{ 'purchase.yourOrder' | translate }}
				}
			}
		</h3>
	</ng-container>

	<ng-container slot="content">
		@switch (data.type) {
			@case ('PackageRequest') {
				<div class="package-request w-100">
					<span>{{ 'purchase.packageRequestText' | translate }}</span>
					<span>{{ 'purchase.leaveComment' | translate }}</span>
					<alaris-text-area
						[formControl]="comment"
						errorMode="touched"
						[required]="true"
						[autofocus]="true"
						data-testid="commentTextarea"
					>
						{{ 'gl.comment' | translate }}
					</alaris-text-area>
				</div>
			}
			@case ('PlanRequest') {
				<div class="plan-request w-100">
					<span>{{ 'purchase.planRequestText' | translate }}</span>
					<span>{{ 'purchase.leaveComment' | translate }}</span>
					<alaris-text-area
						[formControl]="comment"
						errorMode="touched"
						[required]="true"
						[autofocus]="true"
						data-testid="commentTextarea"
					>
						{{ 'gl.comment' | translate }}
					</alaris-text-area>
				</div>
			}
			@case ('SelectPlan') {
				<div class="card">
					<div class="name">
						<alaris-icon [name]="cu.icon(plan.trafficType)" class="channel-icon"></alaris-icon>
						{{ plan.name }}
					</div>
					<ul class="details">
						<li class="row">
							<span class="row__title">{{ 'purchase.channel' | translate }}</span>
							<b>{{ cu.name(plan.trafficType) | translate }}</b>
						</li>
						<li class="row">
							<span class="row__title">{{ 'purchase.country' | translate }}</span>
							<b class="countries">
								<span class="text-truncate">{{ plan.countries!.slice(0, 2).join(', ') }}</span>
								@if (plan.countries!.length > 2) {
									<alaris-tag
										(click)="seeAllCountries()"
										[alarisTooltip]="'purchase.allCountryHint' | translate"
										[rounded]="true"
										style="transform: scale(0.75); cursor: pointer"
									>
										+{{ plan.countries!.length - 2 }}
									</alaris-tag>
								}
							</b>
						</li>
						<li class="row">
							<span class="row__title">{{ 'purchase.billingMode' | translate }}</span>
							<b>
								{{ 'enums.' + plan.billingMode | translate }}
							</b>
						</li>
					</ul>
				</div>
				<alaris-alert class="plan-alert">
					{{ 'purchase.orderNote' | translate }}
				</alaris-alert>
			}
			@case ('ShopNow') {
				<div class="card">
					<div class="name">
						<alaris-icon [name]="cu.icon(package.trafficType)" class="channel-icon"></alaris-icon>
						{{ package.name }}
					</div>
					<ul class="details">
						<li class="row">
							<span class="row__title">{{ 'purchase.channel' | translate }}</span>
							<b>
								{{ cu.name(package.trafficType) | translate }}
								{{
									(package.packSettings.trafficPurpose
										? 'enums.' + package.packSettings.trafficPurpose
										: 'purchase.allTraffic'
									) | translate
								}}
							</b>
						</li>
						<li class="row">
							<span class="row__title">{{ 'purchase.billingMode' | translate }}</span>
							<b>
								{{ 'enums.' + package.billingMode | translate }}
							</b>
						</li>
						<li class="row">
							<span class="row__title">{{ 'purchase.smsCost' | translate }}</span>
							<b>
								<alaris-cost
									[cost]="package.packSettings.packPrice / package.messagesTotal"
									fractionsInfo="2-5"
									[fade]="false"
								></alaris-cost>
							</b>
						</li>
						<li class="row">
							<span class="row__title">{{ 'purchase.smsVolume' | translate }}</span>
							<b>
								{{ package.messagesTotal | number }}
							</b>
						</li>
						<li class="row">
							<span class="row__title">{{ 'purchase.validityPeriod' | translate }}</span>
							<b>
								{{ purchaseService.packActiveTillDate(package) | timeAgo: '' : true | noValue }}
							</b>
						</li>
						<li class="total row">
							<b>{{ 'campaigns.totalCost' | translate }}</b>
							<b>
								<alaris-cost [cost]="package.packSettings.packPrice" fractionsInfo="2-5" [fade]="false"></alaris-cost>
							</b>
						</li>
					</ul>
				</div>

				<app-package-country-network-list [package]="package" class="countries-networks">
				</app-package-country-network-list>

				@if (!positiveBalance) {
					<div class="top-up-alert">
						<alaris-icon name="icon-info"></alaris-icon>
						<div>
							{{ 'purchase.noMoney' | translate }}
							<alaris-link (click)="topUp()" [underline]="false" data-testid="topUpBalanceLink" type="accent">
								{{ 'purchase.topUp' | translate }}
							</alaris-link>
							{{ 'purchase.yourBalance' | translate }}
						</div>
					</div>
				}
			}
		}
	</ng-container>
</alaris-dialog>
